import { generateStaticUrl } from "shared/imports/sharedHelperFunctions"
import swal from "sweetalert"

export const ORG_DESIGN_LINK_FALSE_PREFIX = "/webapps/quorum-site"

export const FOOTER_DEFAULT_TEXT = "Click to add a footer..."
export const ADD_DATA_DESCRIPTION_TEXT = "Add a custom biography..."
export const ADD_CUSTOM_BILL_SUMMARY_TEXT = "Add a custom bill summary..."
export const CUSTOM_NOTES_DESCRIPTION_TEXT = "Click gear to add notes..."
export const CUSTOM_IMAGES_DESCRIPTION_TEXT = "Click gear to add an image..."
export const SECTION_DISABLED_TEXT = "Section Not Available for Selected Official"
export const CUSTOM_DATA_DESCRIPTION_SUMMERNOTE_PLACEHOLDER =
    "Compose your data description. Use '{{' to begin placeholders..."

// defines the available modes for the Download Center
export const MEMBER_PROFILE = "MEMBER_PROFILE"
export const PRESS_CONTACT_PROFILE = "PRESS_CONTACT_PROFILE"
export const REGION_PROFILE = "REGION_PROFILE"
export const BILL_PROFILE = "BILL_PROFILE"

export const PERSON_BATCH_DOWNLOAD = "PERSON_BATCH_DOWNLOAD"
export const STATES_DOWNLOAD = "STATES_DOWNLOAD"
export const CONGRESSIONAL_DISTRICTS_DOWNLOAD = "CONGRESSIONAL_DISTRICTS_DOWNLOAD"
export const SLDU_DOWNLOAD = "SLDU_DOWNLOAD"
export const SLDL_DOWNLOAD = "SLDL_DOWNLOAD"
export const BILL_BATCH_DOWNLOAD = "BILL_BATCH_DOWNLOAD"

export const GLOBAL_DATA_KEY = "globalDatum"
export const TEMPLATE_MANAGER_DATA_KEY = "templateManager"

export const DEFAULT_FIRST_PAGE = "1"
export const DEFAULT_SECOND_PAGE = "2"
export const MAX_NUM_DOWNLOADS = 100

// the map occupies the space of 6 statboxes
export const MAP_STATBOX_OCCUPANCY = 8
// number of regular statboxes per each height increment
export const BASE_NUMBER_OF_STAT_BOXES_PER_LINE = 6
// number of small statboxes per each height increment
export const SMALL_NUMBER_OF_STAT_BOXES_PER_LINE = 6

// number of inlines per each height increment
export const DEFAULT_NUMBER_INLINES_PER_LINE = 4

// the size of PDF header title in terms of the length of string
export const LONG_PDF_HEADER_TITLE_LENGTH = 35
export const XL_PDF_HEADER_TITLE_LENGTH = 40
export const XXL_PDF_HEADER_TITLE_LENGTH = 45
export const XXXL_PDF_HEADER_TITLE_LENGTH = 50

export const PDFDownloadCenterModes = {
    [MEMBER_PROFILE]: MEMBER_PROFILE,
    [REGION_PROFILE]: REGION_PROFILE,
    [BILL_PROFILE]: BILL_PROFILE,
}

export const PDFDownloadCenterSubModes = {
    [MEMBER_PROFILE]: {
        [PERSON_BATCH_DOWNLOAD]: PERSON_BATCH_DOWNLOAD,
    },
    [REGION_PROFILE]: {
        [STATES_DOWNLOAD]: STATES_DOWNLOAD,
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: CONGRESSIONAL_DISTRICTS_DOWNLOAD,
        [SLDU_DOWNLOAD]: SLDU_DOWNLOAD,
        [SLDL_DOWNLOAD]: SLDL_DOWNLOAD,
    },
    [BILL_PROFILE]: {
        [BILL_BATCH_DOWNLOAD]: BILL_BATCH_DOWNLOAD,
    },
}

export const PDFModePreferences = {
    // the text that is used in the "Choose a Mode" toggles
    toggleTextKey: {
        [MEMBER_PROFILE]: "Official",
        [REGION_PROFILE]: "District",
        [BILL_PROFILE]: "Bill",
    },
    // the icons that are used in TemplateManager to indicate which mode a given
    // template is saved in
    templateIcons: {
        [MEMBER_PROFILE]: `fa ${DjangIO.app.models.QuorumDataType.user.icon}`,
        [REGION_PROFILE]: "stateface stateface-us",
        [BILL_PROFILE]: `fa ${DjangIO.app.models.QuorumDataType.bill.icon}`,
    },
    // the tooltips for the "Choose a mode" toggles
    toolTip: {
        [MEMBER_PROFILE]: "Make a downloadable PDF profile of an elected or appointed official.",
        [REGION_PROFILE]: "Make a downloadable PDF profile of a state or district.",
        [BILL_PROFILE]: "Make a downloadable PDF profile of a bill",
    },
}

export const PDFSubModePreferences = {
    // the API resource associated with the submode
    resource: {
        [PERSON_BATCH_DOWNLOAD]: DjangIO.app.person.models.Person,

        [STATES_DOWNLOAD]: DjangIO.app.geography.models.State,
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: DjangIO.app.geography.models.District,
        [SLDU_DOWNLOAD]: DjangIO.app.geography.models.UpperLD,
        [SLDL_DOWNLOAD]: DjangIO.app.geography.models.LowerLD,

        [BILL_BATCH_DOWNLOAD]: DjangIO.app.bill.models.Bill,
    },
    // the key used to lookup the object being rendered (makes a detail request
    // with the currentRenderId)
    dataKey: {
        [PERSON_BATCH_DOWNLOAD]: "id",

        [STATES_DOWNLOAD]: "region",
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: "fips_code",
        [SLDU_DOWNLOAD]: "id",
        [SLDL_DOWNLOAD]: "id",

        [BILL_BATCH_DOWNLOAD]: "id",
    },
    // the display name from the API response object
    displayKeyFromApiResponse: {
        [PERSON_BATCH_DOWNLOAD]: "name",

        [STATES_DOWNLOAD]: "name",
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: "name",
        [SLDU_DOWNLOAD]: "kw_Description",
        [SLDL_DOWNLOAD]: "kw_Description",
        [BILL_BATCH_DOWNLOAD]: "label",
    },
    // the stat API resource associated with the submode
    statResource: {
        [PERSON_BATCH_DOWNLOAD]: DjangIO.app.stats.models.PersonStats,

        [STATES_DOWNLOAD]: DjangIO.app.geography.models.StateStats,
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: DjangIO.app.geography.models.DistrictStats,
        [SLDU_DOWNLOAD]: DjangIO.app.geography.models.LowerLDStats,
        [SLDL_DOWNLOAD]: DjangIO.app.geography.models.UpperLDStats,

        [BILL_BATCH_DOWNLOAD]: undefined, //DjangIO.app.stats.models.BillStats, //or undefined?
    },
    // the key used to lookup the on the statResource for object being rendered
    // (makes a detail request with the currentRenderId)
    statsFilterKey: {
        [PERSON_BATCH_DOWNLOAD]: "id",

        [STATES_DOWNLOAD]: "state__name",
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: "district__fips_code",
        [SLDU_DOWNLOAD]: "upper_ld__id",
        [SLDL_DOWNLOAD]: "lower_ld__id",

        [BILL_BATCH_DOWNLOAD]: "id",
    },
    // the key to publish from a select in the "Choose an Example" step
    previewSelectorKey: {
        [PERSON_BATCH_DOWNLOAD]: "id",

        [STATES_DOWNLOAD]: "value",
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: "fips_code",
        [SLDU_DOWNLOAD]: "id",
        [SLDL_DOWNLOAD]: "id",

        [BILL_BATCH_DOWNLOAD]: "id",
    },
    // the key used to lookup custom data about the person or region
    customDataKey: {
        [PERSON_BATCH_DOWNLOAD]: undefined,

        [STATES_DOWNLOAD]: "state",
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: "cd",
        [SLDU_DOWNLOAD]: "sldu",
        [SLDL_DOWNLOAD]: "sldl",

        [BILL_BATCH_DOWNLOAD]: undefined,
    },
    regionalFilterKey: {
        [PERSON_BATCH_DOWNLOAD]: undefined,

        [STATES_DOWNLOAD]: "name",
        [CONGRESSIONAL_DISTRICTS_DOWNLOAD]: "state__name",
        [SLDU_DOWNLOAD]: "state__name",
        [SLDL_DOWNLOAD]: "state__name",

        [BILL_BATCH_DOWNLOAD]: undefined,
    },
}

export const US_TOPOLOGIES_REQUEST = {
    dataKey: "usTopology",
    url: generateStaticUrl("/static/data/maps/us.static"),
    format: (str) => JSON.parse(str),
}

export const US_CITIES_REQUEST = {
    dataKey: "topCities",
    url: generateStaticUrl("/static/data/maps/top_735_cities_0.static"),
    format: (str) => JSON.parse(str),
}

export const ORGANIZATION_DESIGN_REQUEST = {
    dataKey: "orgDesignObjects",
    url: DjangIO.app.userdata.models.OrganizationDesign.objects
        .filter({ organization: Userdata.organization_id })
        .limit(1000)
        .buildUrl(),
    format: (json) => json.objects,
}

export const CacheRequests = [US_TOPOLOGIES_REQUEST, US_CITIES_REQUEST, ORGANIZATION_DESIGN_REQUEST]

// every display element has a defaultProp called defaultHeight that is an
// integer from 1 to 6. these represent how much of each page they occupy
// (e.g. a display element with defaultHeight = 2 would have height 2/6 of
// the page height)
export const MAX_PAGE_HEIGHT = 6
export const MIN_ELEMENT_HEIGHT = 1
export const PAGE_HEIGHT_CM = 23.9

export const pageTooFull = (element, currentPage, addPage, addElement) => {
    swal({
        buttons: ["Cancel", "Yes"],
        title: "Add Another Page?",
        text: "There is not enough space to fit this element on this page. Would you like to add this element to a new page?",
        icon: "warning",
    }).then((isConfirm) => {
        if (isConfirm) {
            const newPageNum = +currentPage + 1
            addPage(newPageNum)
            addElement(element, newPageNum)
            return swal("Added!", "Your element has been added.", "success")
        } else {
            return null
        }
    })
}

// Documentation in PDFComponentKeys.jsx for this weirdness
export const PDF_PERSON_STATS_ROW_KEY = "PDFPersonStatsRow"
export const PDF_REGION_STATS_ROW_KEY = "PDFRegionStatsRowMap"
export const PDF_REGION_STATS_ROW_NO_MAP_KEY = "PDFRegionStatsRowNoMap"
export const PDF_BIOGRAPHY_ROW_KEY = "PDFBiographyRow"
export const PDF_DOCUMENT_ROW_KEY = "PDFDocumentRow"
export const PDF_SPONSORED_BILL_ROW_KEY = "PDFSponsoredBillRow"
export const PDF_COSPONSORED_BILL_ROW_KEY = "PDFCosponsoredBillRow"
export const PDF_RELATED_BILL_ROW_KEY = "PDFRelatedBillRow"
export const PDF_MAP_KEY = "PDFMap"
export const PDF_NOTE_ROW_KEY = "PDFNoteRow"
export const PDF_STAFFER_ROW_KEY = "PDFStafferRow"
export const PDF_CUSTOM_NOTES_ROW_KEY = "PDFCustomNotesRow"
export const PDF_COMMITTEE_ROW_KEY = "PDFCommitteeRow"
export const PDF_CAUCUS_ROW_KEY = "PDFCaucusRow"
export const PDF_PLACEHOLDER_KEY = "PDFPlaceHolder"
export const PDF_CUSTOM_GEO_DATA_ROW_KEY = "PDFCustomGeoDataRow"
export const PDF_CUSTOM_GEO_DATA_LIST_KEY = "PDFCustomGeoDataList"
export const PDF_VOTE_ROW = "PDFVoteRow"
export const PDF_LISTS_ROW = "PDFListsRow"
export const PDF_IMAGE_ROW_KEY = "PDFImageRow"
export const PDF_BILL_SUMMARY_ROW_KEY = "PDFBillSummaryRow"
export const PDF_BILL_FULL_TITLE_ROW_KEY = "PDFBillFullTitleRow"
export const PDF_BILL_SPONSORS_ROW_KEY = "PDFBillSponsorsRow"
export const PDF_BILL_TIMELINE_ROW_KEY = "PDFBillTimelineRow"
export const PDF_AMENDMENT_ROW_KEY = "PDFAmendmentRow"
export const PDF_BILL_ORG_DETAILS_ROW_KEY = "PDFBillOrgDetailsRow"
export const PDF_REPRESENTING_REGION_ROW_KEY = "PDFRepresentingRegionRow"
export const COSPONSORS_MOST_STAT_LIST_KEY = "cosponsors_most_stat_list"
export const TOP_ISSUES_SPONSORED_OR_COSPONSORED_ENACTED_STAT_LIST_KEY =
    "top_issues_sponsored_or_cosponsored_enacted_stat_list"
export const TOP_ISSUES_VETOED_STAT_LIST_KEY = "top_issues_vetoed_stat_list"
export const MOST_SPONSORING_ENACTED_STAT_LIST_KEY = "most_sponsoring_enacted_stat_list"
export const TOP_MEMBERS_SPONSORED_OUT_OF_COMMITTEE_STAT_LIST_KEY = "top_members_sponsored_out_of_committee_stat_list"
export const WORKED_TOGETHER_ON_LEGISLATION_STAT_LIST_KEY = "worked_together_on_legislation_stat_list"
export const TOP_ISSUES_SPONSORED_ENACTED_STAT_LIST_KEY = "top_issues_sponsored_enacted_stat_list"
export const WORKS_ON_LEGISLATION_WITH_MOST_STAT_LIST_KEY = "works_on_legislation_with_most_stat_list"
export const MOST_SPONSORING_VETOED_STAT_LIST_KEY = "most_sponsoring_vetoed_stat_list"
export const MENTIONS_MOST_IN_DOCUMENT_STAT_LIST_KEY = "mentions_most_in_document_stat_list"
export const TOP_ISSUES_ENACTED_STAT_LIST_KEY = "top_issues_enacted_stat_list"
export const MENTIONED_BY_MOST_IN_DOCUMENT_STAT_LIST_KEY = "mentioned_by_most_in_document_stat_list"
export const TOP_ISSUES_SPONSORED_OR_COSPONSORED_OUT_OF_COMMITTEE_STAT_LIST_KEY =
    "top_issues_sponsored_or_cosponsored_out_of_committee_stat_list"
export const VOTES_WITH_MOST_STAT_LIST_KEY = "votes_with_most_stat_list"
export const TOP_MEMBERS_SPONSORED_ENACTED_STAT_LIST_KEY = "top_members_sponsored_enacted_stat_list"
export const SPONSORS_WITH_MOST_STAT_LIST_KEY = "sponsors_with_most_stat_list"
export const SHARED_COMMITTEES_STAT_LIST_KEY = "shared_committees_stat_list"
export const MOST_COSPONSORED_BY_STAT_LIST_KEY = "most_cosponsored_by_stat_list"
export const TOP_MEMBERS_COSPONSORED_STAT_LIST_KEY = "top_members_cosponsored_stat_list"
export const TOP_ISSUES_SPONSORED_OR_COSPONSORED_STAT_LIST_KEY = "top_issues_sponsored_or_cosponsored_stat_list"
export const TOP_MEMBERS_SPONSORED_STAT_LIST_KEY = "top_members_sponsored_stat_list"
export const TOP_ISSUES_SPONSORED_OUT_OF_COMMITTEE_STAT_LIST_KEY = "top_issues_sponsored_out_of_committee_stat_list"
export const TOP_ISSUES_COSPONSORED_STAT_LIST_KEY = "top_issues_cosponsored_stat_list"
export const TOP_ISSUES_SPONSORED_STAT_LIST_KEY = "top_issues_sponsored_stat_list"
export const SHARED_CAUCUSES_STAT_LIST_KEY = "shared_caucuses_stat_list"
export const TOP_MEMBERS_SPONSORED_OR_COSPONSORED_STAT_LIST_KEY = "top_members_sponsored_or_cosponsored_stat_list"

const formatLongPillText = (text, width = 5, altText = "None") => {
    if (!text) {
        return altText
    }
    // ~9 chars per width increase
    const maxLength = width * 9
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text
}

export const FEDERAL_BIO_PILLS = [
    {
        key: "num_terms",
        icon: "fa-bank",
        width: 2,
        formatText: (text) => (text ? `${text} Terms` : "First Term"),
    },
    {
        key: "twitterid",
        icon: "fa-twitter",
        width: 3,
        formatText: (text) => (text !== null ? `@${text}` : "No Twitter Handle"),
    },
    {
        key: "phone",
        icon: "fa-phone",
        width: 2,
        formatText: (text) => (text !== null ? `${text}` : "No Phone"),
    },
    {
        key: "address",
        icon: "fa-map-marker",
        width: 5,
        formatText: formatLongPillText,
        altText: "No Address",
    },
]

export const MEMBER_BIO_PILLS = [
    {
        key: "twitterid",
        icon: "fa-twitter",
        width: 3,
        formatText: (text) => (text !== null ? `@${text}` : "No Twitter Handle"),
    },
    {
        key: "phone",
        icon: "fa-phone",
        width: 2,
        formatText: (text) => (text !== null ? `${text}` : "No Phone"),
    },
    {
        key: "address",
        icon: "fa-map-marker",
        width: 5,
        formatText: formatLongPillText,
        altText: "No Address",
    },
]

export const EXECUTIVE_BIO_PILLS = [
    {
        key: "email",
        icon: "fa-envelope",
        width: 5,
        formatText: formatLongPillText,
        altText: "No Email",
    },
    {
        key: "phone",
        icon: "fa-phone",
        width: 2,
        formatText: (text) => (text !== null ? `${text}` : "No Phone"),
    },
    {
        key: "address",
        icon: "fa-map-marker",
        width: 5,
        formatText: formatLongPillText,
        altText: "No Address",
    },
]

export const generateStatBoxesForPersonType = (personRole) =>
    DjangIO.app.stats.types.NewStatsType.items()
        .filter(
            (stat) =>
                stat.stats_type === DjangIO.app.stats.types.NewStatsFormat.raw_stat.label &&
                stat.qdt === DjangIO.app.models.QuorumDataType.person.value &&
                stat.supported_person_types &&
                stat.supported_person_types.includes &&
                stat.supported_person_types.includes(personRole.value)
        )
        .map((stat) => ({ full_name: stat.label, slug_name: stat.slug }))

export const DEFAULT_MEMBER_STAT_BOX_KEYS = generateStatBoxesForPersonType(
    DjangIO.app.person.newtypes.MinorRoleType.us_senator
)
export const DEFAULT_GOVERNOR_STAT_BOX_KEYS = generateStatBoxesForPersonType(
    DjangIO.app.person.newtypes.MinorRoleType.us_governor
)

export const EXCLUDED_FROM_DEFAULT_STAT_BOX_KEYS = []
    .concat(
        // in the future, more defaults will be added here, like EU members, and
        // others that we add person stats for
        DEFAULT_GOVERNOR_STAT_BOX_KEYS
    )
    .map((defaultItem) => defaultItem.slug_name)

export const EXCLUDED_FROM_DEFAULT_STAT_BOX_IDS = []
    .concat(
        // in the future, more defaults will be added here, like EU members, and
        // others that we add person stats for
        DEFAULT_GOVERNOR_STAT_BOX_KEYS
    )
    .map((defaultItem) => defaultItem.id)

export const DEFAULT_REGION_STATISTICS = [
    {
        full_name: "Total population",
        slug_name: "DP05_0001E",
    },
    {
        full_name: "Total households",
        slug_name: "DP02_0001E",
    },
    {
        full_name: "INCOME AND BENEFITS (IN 2013 INFLATION-ADJUSTED DOLLARS)!!Families!!Per capita income (dollars)",
        slug_name: "DP03_0088E",
    },
    {
        full_name: "EMPLOYMENT STATUS!!Civilian labor force!!Percent Unemployed",
        slug_name: "DP03_0009PE",
    },
    {
        full_name: "COMPUTERS AND INTERNET USE!!Total Households!!With a computer",
        slug_name: "DP02_0151PE",
    },
    {
        full_name: "Foreign Born Population",
        slug_name: "DP02_0092PE",
    },
]

export const DEFAULT_BILL_FULL_TITLE_FONT_SIZE = [
    {
        componentName: "billTitleFontSize",
        fontSize: "15pt",
    },
    {
        componentName: "billStatusFontSize",
        fontSize: "12pt",
    },
    {
        componentName: "billCommitteesFontSize",
        fontSize: "12pt",
    },
    {
        componentName: "billSourceLinkFontSize",
        fontSize: "11pt",
    },
]

export const tooManyStats = () =>
    swal(
        "Oops...",
        "There is not enough space in this element to add another statistic box. Try expanding this element to fit more statistics.",
        "error"
    )

export const KEYS_TO_CLEAN = [
    "displayElement",
    "data",
    "dataDescription",
    "dataDescriptionFilter",
    "filter",
    "initialFilter",
    "custom_quorum_biography",
    "custom_kw_biography",
    "custom_html_content", // custom official bill summary
]

const cleanIndividualElement = (datum) =>
    // iterates over each key of each element in the stoer and cleans
    // out unecessary data before being sent to the backend for bulk
    // downloading
    Object.keys(datum).reduce(
        (prevDataVal, dataKey) =>
            !KEYS_TO_CLEAN.includes(dataKey) && !dataKey.endsWith("Request")
                ? Object.assign({}, prevDataVal, { [dataKey]: datum[dataKey] })
                : prevDataVal,
        {}
    )

const cleanElementDetails = (elementDetails) =>
    // iterate over all display elements in the store and cleans out
    // the fields that do not need to be sent to the backend for bulk
    // downloading
    Object.keys(elementDetails).reduce((prevElementVal, elementKey) => {
        const datum = elementDetails[elementKey]
        const cleanedDatum = elementKey !== GLOBAL_DATA_KEY ? cleanIndividualElement(datum) : {}

        return Object.assign({}, prevElementVal, { [elementKey]: cleanedDatum })
    }, {})

export const getCleanStore = (profileDownloadCenter, currentSubMode) => {
    const stateToTemplatify = profileDownloadCenter.toJS()

    // clean unecessary element data for a simpler JSON to send
    const { elementDetails } = stateToTemplatify
    stateToTemplatify.elementDetails = cleanElementDetails(elementDetails)

    stateToTemplatify.currentSubMode = currentSubMode
    stateToTemplatify.currentPage = Object.keys(stateToTemplatify.pages)[0]

    stateToTemplatify.currentRenderId = undefined

    // return the cleaned, minified store
    return stateToTemplatify
}

export const currentRegionNotSupportedByElement = (personObj, displayElement) => {
    // if the chosen person is from a region that the element does not support
    // (ex: if this component contains census data, but the selected member
    // is from Puerto Rico or a Federal Executive)
    const excludedRegions = displayElement.prototype.componentExcludedRegions

    // if the component has excluded regions
    return (
        excludedRegions &&
        personObj.most_recent_state_abbrev &&
        excludedRegions.includes(personObj.most_recent_state_abbrev.toLowerCase())
    )
}

export const currentPersonTypeNotSupportedByElement = (personObj, displayElement) => {
    // If the element contains information that isn't supported by the selected
    // person's roletype (ex: Legislative Statistics for an Attorney General)

    const excludedRoleTypes = displayElement.prototype.componentExcludedRoleTypes

    const excludedByRole = excludedRoleTypes && excludedRoleTypes.includes(personObj.most_recent_role_type)

    return excludedByRole
}

export const getPDFSummernoteHeight = (containerHeight, offset) => {
    // 2cm is the minimum textbox height
    const minHeight = 2
    const sectionHeight = PAGE_HEIGHT_CM * (containerHeight / MAX_PAGE_HEIGHT)
    const tempTextboxHeight = sectionHeight - offset
    const textboxHeight = tempTextboxHeight > minHeight ? tempTextboxHeight : minHeight
    return textboxHeight
}

export const HIDDEN_CUSTOM_DATA_VALUES = ["id", "ID", "lat", "lon", "unique_identifier"]

export const DEFAULT_CUSTOM_DATA_VALUES = ["name", "address"]

export const formatStatsForSelect = (stats) => (stats ? stats.map((stat, idx) => ({ value: idx, label: stat })) : [])
